export default __webpack_public_path__ + "static/media/refund.aa945285.png";